import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Home, FolderKanban, List, BarChart3, ChevronLeft, ListChecks, LayoutDashboard, FileText } from 'lucide-react';
import { Toaster } from '@/components/ui/sonner';

const navItems = [
  { to: '/programs', icon: FolderKanban, label: 'Dashboard', end: true },
  { to: '/programs/list', icon: List, label: 'Programs' },
  { to: '/programs/my-tasks', icon: ListChecks, label: 'My Tasks' },
  { to: '/programs/task-dashboard', icon: LayoutDashboard, label: 'Task Dashboard' },
  { to: '/programs/reports/sales-spend', icon: FileText, label: 'Sales & Spend' },
];

export default function ProgramLayout() {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen bg-background">
      <Toaster position="top-right" richColors />
      <aside className="w-48 border-r bg-card flex flex-col">
        <div className="p-3 border-b">
          <button onClick={() => navigate('/')} className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">
            <Home className="w-3.5 h-3.5" /> ERP Home
          </button>
          <h2 className="font-heading text-sm font-bold mt-1.5 tracking-tight flex items-center gap-1.5">
            <FolderKanban className="w-4 h-4" /> Program Management
          </h2>
        </div>
        <nav className="flex-1 p-2 space-y-0.5">
          {navItems.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs transition-colors ${
                  isActive ? 'bg-primary/10 text-primary font-medium' : 'text-muted-foreground hover:bg-muted'
                }`
              }
            >
              <item.icon className="w-3.5 h-3.5" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t">
          <button onClick={() => navigate('/')} className="flex items-center gap-1 text-[11px] text-muted-foreground hover:text-foreground transition-colors">
            <ChevronLeft className="w-3 h-3" /> Back to Home
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="p-6 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
